import React from "react";

function Contact() {
  return (
    <div className="page-shell">
      <section className="page-hero page-hero-light">
        <div className="container">
          <p className="eyebrow">Contact</p>
          <h1>Let’s discuss your packaging requirement</h1>
          <p>
            Share your requirement, plant location, expected volume, or product dimensions. Our team will get back to
            you quickly.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container contact-layout">
          <div className="contact-panel">
            <p className="eyebrow">Send Inquiry</p>
            <h2>Contact form</h2>
            <form className="contact-form">
              <div className="form-grid">
                <label className="form-field">
                  <span>Name</span>
                  <input type="text" name="name" placeholder="Your name" />
                </label>
                <label className="form-field">
                  <span>Phone</span>
                  <input type="tel" name="phone" placeholder="+91" />
                </label>
                <label className="form-field">
                  <span>Email</span>
                  <input type="email" name="email" placeholder="your@email.com" />
                </label>
                <label className="form-field">
                  <span>Subject</span>
                  <input type="text" name="subject" placeholder="Packaging requirement" />
                </label>
              </div>
              <label className="form-field">
                <span>Message</span>
                <textarea name="message" rows="6" placeholder="Tell us what you need"></textarea>
              </label>
              <button type="submit" className="btn btn-primary form-submit">
                Submit
              </button>
            </form>
          </div>

          <div className="contact-panel contact-details">
            <p className="eyebrow">Reach Us</p>
            <h2>Direct contact information</h2>
            <div className="contact-detail-item">
              <h3>Phone</h3>
              <p> +91 94435 11714</p>
              <p> +91 86674 31339</p>
            </div>
            <div className="contact-detail-item">
              <h3>Email</h3>
              <p> info@saivenkateshwarapackage.com</p>
            </div>
            <div className="contact-detail-item">
              <h3>Plant 1</h3>
              <p>Sl.No 232/1B1, 232/2, 239/1
Pathakotta to Ramapura Road
Shoolagiri (Taluk), Krishnagiri (District)
Tamil Nadu - 635117</p>
            </div>
            
          </div>
        </div>
      </section>

      <section className="section section-muted">
        <div className="container">
          <div className="section-heading">
            <p className="eyebrow">Location</p>
            <h2>Google map</h2>
            <p>Map embed is ready and can be replaced with the exact business listing URL if you want to use your final map link.</p>
          </div>
          <div className="map-frame">
            <iframe
              title="Sai Venkateshwara Packages map"
              src="https://www.google.com/maps?q=Hosur%20Tamil%20Nadu&z=12&output=embed"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
